import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ArrowLeftIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 16 12'}>
    <path
      d="M15.605 5.99997C15.605 6.43997 15.245 6.79997 14.805 6.79997H3.12503L6.74503 10.44C7.06503 10.76 7.06503 11.26 6.74503 11.58C6.58503 11.74 6.38503 11.82 6.18503 11.82C5.98503 11.82 5.76503 11.74 5.62503 11.58L0.645032 6.57997C0.325032 6.25997 0.325032 5.75997 0.645032 5.45997L5.62503 0.459968C5.94503 0.139968 6.44503 0.139968 6.76503 0.459968C7.08503 0.779968 7.08503 1.27997 6.76503 1.59997L3.12503 5.19997H14.805C15.245 5.19997 15.605 5.55997 15.605 5.99997Z"
      fill="#2371A5"
    />
  </BaseIcon>
);

export default ArrowLeftIcon;
